// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3n3Vi","col":"styles_col__EH4JK"};